// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsBom3-Bom3Positions-Bom3PositionsTable-Bom3PositionsTable-module__main--Jta6Q {
  flex: 1;
  overflow: auto;
  padding: 0 24px;
  border-top: thin solid rgba(0, 0, 0, 0.06);
  position: relative;
}
.src-businessServices-services-bsBom3-Bom3Positions-Bom3PositionsTable-Bom3PositionsTable-module__table--KYeS2 {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: clip;
}
.src-businessServices-services-bsBom3-Bom3Positions-Bom3PositionsTable-Bom3PositionsTable-module__theadBox--qDhBJ {
  overflow: clip;
}
.src-businessServices-services-bsBom3-Bom3Positions-Bom3PositionsTable-Bom3PositionsTable-module__thead--H83Nf {
  display: grid;
  overflow: hidden;
}
.src-businessServices-services-bsBom3-Bom3Positions-Bom3PositionsTable-Bom3PositionsTable-module__tbodyBox--xfeHU {
  flex: 1;
  overflow: auto;
}
.src-businessServices-services-bsBom3-Bom3Positions-Bom3PositionsTable-Bom3PositionsTable-module__tbody--HibG2 {
  display: grid;
}
.src-businessServices-services-bsBom3-Bom3Positions-Bom3PositionsTable-Bom3PositionsTable-module__th--jQ8P0 {
  position: relative;
  display: flex;
  border-bottom: thin solid rgba(0, 0, 0, 0.06);
  border-right: thin solid rgba(0, 0, 0, 0.06);
  background: #fafafa;
}
.src-businessServices-services-bsBom3-Bom3Positions-Bom3PositionsTable-Bom3PositionsTable-module__thTitle--uUr1z {
  flex: 1;
  padding: 4px 8px;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.55);
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}
.src-businessServices-services-bsBom3-Bom3Positions-Bom3PositionsTable-Bom3PositionsTable-module__cellFirst--nPcht {
  border-bottom: thin solid rgba(0, 0, 0, 0.06);
  border-right: thin solid rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
}
.src-businessServices-services-bsBom3-Bom3Positions-Bom3PositionsTable-Bom3PositionsTable-module__fixedCell--qun0d {
  position: sticky;
  z-index: 10;
  background-color: #fff;
}
.src-businessServices-services-bsBom3-Bom3Positions-Bom3PositionsTable-Bom3PositionsTable-module__fixedOverlap--WIs9f {
  box-shadow: 10px 0 8px -8px rgba(5, 5, 5, 0.1);
}
.src-businessServices-services-bsBom3-Bom3Positions-Bom3PositionsTable-Bom3PositionsTable-module__fixedLastCell--StqU1 {
  border-right: thin solid rgba(0, 0, 0, 0.06) !important;
}
.src-businessServices-services-bsBom3-Bom3Positions-Bom3PositionsTable-Bom3PositionsTable-module__materialRow--LElJG {
  background: #f0f0f0;
}
.src-businessServices-services-bsBom3-Bom3Positions-Bom3PositionsTable-Bom3PositionsTable-module__materialCell--s0CtK {
  border-bottom: thin solid rgba(0, 0, 0, 0.06);
  padding: 8px;
  min-width: max-content;
  display: flex;
  align-items: center;
  gap: 8px;
}
.src-businessServices-services-bsBom3-Bom3Positions-Bom3PositionsTable-Bom3PositionsTable-module__materialCell--s0CtK .ant-btn-icon {
  transition: transform 200ms ease-in-out;
}
.src-businessServices-services-bsBom3-Bom3Positions-Bom3PositionsTable-Bom3PositionsTable-module__materialCell--s0CtK .src-businessServices-services-bsBom3-Bom3Positions-Bom3PositionsTable-Bom3PositionsTable-module__collapsed--bANDT .ant-btn-icon {
  transform: rotate(180deg);
}
.src-businessServices-services-bsBom3-Bom3Positions-Bom3PositionsTable-Bom3PositionsTable-module__materialName--WaqQS {
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 160%;
  white-space: nowrap;
}
.src-businessServices-services-bsBom3-Bom3Positions-Bom3PositionsTable-Bom3PositionsTable-module__td--f7gjP {
  padding: 8px;
}
.src-businessServices-services-bsBom3-Bom3Positions-Bom3PositionsTable-Bom3PositionsTable-module__overlay--ySyEU {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.75);
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsBom3/Bom3Positions/Bom3PositionsTable/Bom3PositionsTable.module.less"],"names":[],"mappings":"AAIA;EACE,OAAA;EACA,cAAA;EACA,eAAA;EACA,0CAAA;EACA,kBAAA;AAHF;AAMA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;AAJF;AAOA;EACE,cAAA;AALF;AAQA;EACE,aAAA;EACA,gBAAA;AANF;AASA;EACE,OAAA;EACA,cAAA;AAPF;AASA;EACE,aAAA;AAPF;AAUA;EACE,kBAAA;EACA,aAAA;EAEA,6CAAA;EACA,4CAAA;EACA,mBAAA;AATF;AAYA;EACE,OAAA;EACA,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,uBAAA;EACA,mBAAA;EAEA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAXF;AAcA;EACE,6CAAA;EACA,4CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAZF;AAeA;EACE,gBAAA;EACA,WAAA;EACA,sBAAA;AAbF;AAgBA;EACE,8CAAA;AAdF;AAgBA;EACE,uDAAA;AAdF;AAiBA;EACE,mBAAA;AAfF;AAmBA;EACE,6CAAA;EACA,YAAA;EACA,sBAAA;EAEA,aAAA;EACA,mBAAA;EACA,QAAA;AAlBF;AAWA;EAUI,uCAAA;AAlBJ;AAQA;EAcM,yBAAA;AAnBN;AAwBA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAtBF;AAyBA;EACE,YAAA;AAvBF;AA0BA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,2CAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;AAzBF","sourcesContent":["@border: thin solid rgba(0, 0, 0, 0.06);\n@horizSpace: 24px;\n\n// Предполагается, что контейнер flex-direction: column\n.main {\n  flex: 1;\n  overflow: auto;\n  padding: 0 @horizSpace;\n  border-top: @border;\n  position: relative;\n}\n\n.table {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: clip;\n}\n\n.theadBox {\n  overflow: clip;\n}\n\n.thead {\n  display: grid;\n  overflow: hidden;\n}\n\n.tbodyBox {\n  flex: 1;\n  overflow: auto;\n}\n.tbody {\n  display: grid;\n}\n\n.th {\n  position: relative;\n  display: flex;\n\n  border-bottom: @border;\n  border-right: @border;\n  background: #fafafa;\n}\n\n.thTitle {\n  flex: 1;\n  padding: 4px 8px;\n  overflow: hidden;\n  color: rgba(0, 0, 0, 0.55);\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 150%;\n}\n\n.cellFirst {\n  border-bottom: @border;\n  border-right: @border;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.fixedCell {\n  position: sticky;\n  z-index: 10;\n  background-color: #fff;\n}\n\n.fixedOverlap {\n  box-shadow: 10px 0 8px -8px rgba(5, 5, 5, 0.1);\n}\n.fixedLastCell {\n  border-right: @border !important;\n}\n\n.materialRow {\n  background: #f0f0f0;\n}\n\n// Контейнер для кнопки добавления новой позиции и для названия материала\n.materialCell {\n  border-bottom: @border;\n  padding: 8px;\n  min-width: max-content;\n\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  :global(.ant-btn-icon) {\n    transition: transform 200ms ease-in-out;\n  }\n  .collapsed {\n    :global(.ant-btn-icon) {\n      transform: rotate(180deg);\n    }\n  }\n}\n\n.materialName {\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 160%;\n  white-space: nowrap;\n}\n\n.td {\n  padding: 8px;\n}\n\n.overlay {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(255, 255, 255, 0.75);\n  z-index: 1;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `src-businessServices-services-bsBom3-Bom3Positions-Bom3PositionsTable-Bom3PositionsTable-module__main--Jta6Q`,
	"table": `src-businessServices-services-bsBom3-Bom3Positions-Bom3PositionsTable-Bom3PositionsTable-module__table--KYeS2`,
	"theadBox": `src-businessServices-services-bsBom3-Bom3Positions-Bom3PositionsTable-Bom3PositionsTable-module__theadBox--qDhBJ`,
	"thead": `src-businessServices-services-bsBom3-Bom3Positions-Bom3PositionsTable-Bom3PositionsTable-module__thead--H83Nf`,
	"tbodyBox": `src-businessServices-services-bsBom3-Bom3Positions-Bom3PositionsTable-Bom3PositionsTable-module__tbodyBox--xfeHU`,
	"tbody": `src-businessServices-services-bsBom3-Bom3Positions-Bom3PositionsTable-Bom3PositionsTable-module__tbody--HibG2`,
	"th": `src-businessServices-services-bsBom3-Bom3Positions-Bom3PositionsTable-Bom3PositionsTable-module__th--jQ8P0`,
	"thTitle": `src-businessServices-services-bsBom3-Bom3Positions-Bom3PositionsTable-Bom3PositionsTable-module__thTitle--uUr1z`,
	"cellFirst": `src-businessServices-services-bsBom3-Bom3Positions-Bom3PositionsTable-Bom3PositionsTable-module__cellFirst--nPcht`,
	"fixedCell": `src-businessServices-services-bsBom3-Bom3Positions-Bom3PositionsTable-Bom3PositionsTable-module__fixedCell--qun0d`,
	"fixedOverlap": `src-businessServices-services-bsBom3-Bom3Positions-Bom3PositionsTable-Bom3PositionsTable-module__fixedOverlap--WIs9f`,
	"fixedLastCell": `src-businessServices-services-bsBom3-Bom3Positions-Bom3PositionsTable-Bom3PositionsTable-module__fixedLastCell--StqU1`,
	"materialRow": `src-businessServices-services-bsBom3-Bom3Positions-Bom3PositionsTable-Bom3PositionsTable-module__materialRow--LElJG`,
	"materialCell": `src-businessServices-services-bsBom3-Bom3Positions-Bom3PositionsTable-Bom3PositionsTable-module__materialCell--s0CtK`,
	"collapsed": `src-businessServices-services-bsBom3-Bom3Positions-Bom3PositionsTable-Bom3PositionsTable-module__collapsed--bANDT`,
	"materialName": `src-businessServices-services-bsBom3-Bom3Positions-Bom3PositionsTable-Bom3PositionsTable-module__materialName--WaqQS`,
	"td": `src-businessServices-services-bsBom3-Bom3Positions-Bom3PositionsTable-Bom3PositionsTable-module__td--f7gjP`,
	"overlay": `src-businessServices-services-bsBom3-Bom3Positions-Bom3PositionsTable-Bom3PositionsTable-module__overlay--ySyEU`
};
export default ___CSS_LOADER_EXPORT___;
